<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Müşteri Emaili Düzenle</h4>
              <p class="card-category">Müşteriye ait bir hesap, tanıtım maili bu emaile gidecektir.</p>
            </template>


            <form class="m-5">
              <div class="row">
                <div class="col-md-4">
                  <base-input type="email" label="Email" placeholder="Email" v-model="payload.mail">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Şirket İsmi" placeholder="Şirket İsmi" v-model="payload.companyName">
                  </base-input>
                </div>
              </div>


              <label>Grup Seçimi</label>

              <div class="row" v-for="group of mailGroups" :key="group._id">
                <div class="col-md-4">
                  <label>{{ group.title }}</label>
                  <base-checkbox @click="selectGroup(group._id)" type="text"
                    :checked="payload.mailGroup.includes(group._id)"
                    :disabled="group.isSpecialGroup && isSpecialGroupSelected && selectedSpecialGroup._id !== group._id">
                  </base-checkbox>
                </div>
              </div>



              <div class="row pt-5">
                <div class="col-md-4">
                  <label>Aktif Mi?</label>
                  <base-checkbox type="text" label="Host" placeholder="Host" v-model="payload.isActive">
                  </base-checkbox>
                </div>
              </div>

              <div class="row pt-5">
                <div class="col-md-4">
                  <label>Mail Aboneniz Mi?</label>
                  <base-checkbox type="text" label="Host" placeholder="Host" v-model="payload.isSubscribed">
                  </base-checkbox>
                </div>
              </div>




              <div class="text-center">
                <button type="submit" class="btn btn-info btn-fill float-right" @click="updateMail()">
                  Güncelle
                </button>
              </div>
              <div class="clearfix"></div>
            </form>

          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";
export default {
  components: {
    Card
  },
  data() {
    return {
      id: null,
      payload: {
        mail: "",
        companyName: "",
        isActive: null,
        isSubscribed: null,
        mailGroup: [],

      },
      isSpecialGroupSelected: false,
      selectedSpecialGroup: null,
      mailGroups: []
    }
  },
  mounted() {
    this.id = window.location.href.split('/').at(-1);
    this.getMailGroups();

  },
  methods: {
    updateMail() {
      CollectionService.updateCollectionItem('mail', this.id, this.payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Mail Güncellendi")
          this.$router.push(`/admin/mails`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    getMailGroups() {

      CollectionService.getCollection('mailGroup').then((res) => {
        if (res.success == true) {
          this.mailGroups = res.mailGroups;
          this.getMail();
        } else {
          console.log('error');
        }
      })
    },
    getMail() {

      CollectionService.getCollectionItemWithId('mail', this.id).then((res) => {
        if (res.success == true) {
          this.payload.mail = res.mail.mail;
          this.payload.companyName = res.mail.companyName;
          this.payload.isActive = res.mail.isActive;
          this.payload.mailGroup = res.mail.mailGroup;
          this.payload.isSubscribed = res.mail.isSubscribed;

          if (res.mail.mailGroup.length > 0) {
            let alreadySelectedSpecialGroup = this.payload.mailGroup.map(x => this.mailGroups.find(y => y._id == x)).find(x => x.isSpecialGroup);
            if (alreadySelectedSpecialGroup) {
              this.isSpecialGroupSelected = true;
              this.selectedSpecialGroup = alreadySelectedSpecialGroup;
            }
          }
        } else {
          console.log('error');
        }
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    selectGroup(_id) {
      const group = this.mailGroups.find(x => x._id == _id);



      if (!this.payload.mailGroup.includes(_id)) {
        this.payload.mailGroup.push(_id);
        if (group.isSpecialGroup) {
          this.isSpecialGroupSelected = true;
          this.selectedSpecialGroup = group;
        }

      } else {
        this.payload.mailGroup = this.payload.mailGroup.filter(x => x != _id)
        if (group.isSpecialGroup) {
          this.isSpecialGroupSelected = false;
          this.selectedSpecialGroup = null;
        }
      }
    }
  }
}
</script>
<style></style>